import Page from 'components/Page'
import Content from 'components/Content'
import AboutView from '../../components/AboutView'

const AboutPage = () => <Page title='About'>
  <Content>
    <AboutView />
  </Content>
</Page>

export default AboutPage
